import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSettingContext } from "context/SettingContext";
import usersAPI from "features/Setting/users/api/userApis";

const useEditUser = ({ sortBy, sortOrder }) => {
  const quaryClient = useQueryClient();
  const { setUserEditMessage, search } = useSettingContext();
  return useMutation({
    mutationFn: usersAPI.EditUserInfo,
    onSuccess: (data) => {
      if (data?.data?.message === "User Profile Updated Successfully") {
        setUserEditMessage(data?.data?.message);
        quaryClient.removeQueries(["users-data", { sortBy, sortOrder, search }]);
        // quaryClient.setQueryData(["users-data", { sortBy, sortOrder }], (oldQueryData) => {
        //   return {
        //     ...oldQueryData,
        //     data: {
        //       ...oldQueryData.data,
        //       message: data?.data?.message,
        //       User: oldQueryData.data.User.map((user) => (user._id === data?.data?.user?._id ? data?.data?.user : user)),
        //     },
        //   };
        // });
      } else {
        throw new Error(data?.data?.message || "An unexpected error occurred");
      }
    },
    onError: (error) => {
      throw new Error(error?.response?.data?.message || error?.message || "An unexpected error occurred");
    },
  });
};

export default useEditUser;
